import update from "immutability-helper";
import { findIndex as _findIndex } from "lodash-es";

import {
  makeObjectsSaved,
  setPendingFlag,
  updateFromFetchUpdates,
} from "../utils";
import { FETCH_UPDATES_SUCCESS, SET_PENDING, SET_SAVED } from "../actions/sync";
import { SET_HUMAN_CONTACT } from "../actions/humanContacts";

export default function humanContacts(state = [], action) {
  switch (action.type) {
    case SET_HUMAN_CONTACT: {
      const humanContactIndex = _findIndex(state, { id: action.id });

      if (humanContactIndex === -1) {
        return [
          ...state,
          {
            id: action.id,
            humanId: action.humanId,
            type: action.valueType,
            value: action.value,
            createdAt: new Date().toISOString(),
            modifiedAt: new Date().toISOString(),
            pending: false,
            modified: true,
          },
        ];
      }

      return update(state, {
        [humanContactIndex]: {
          $merge: {
            humanId: action.humanId,
            type: action.valueType,
            value: action.value,
            modifiedAt: new Date().toISOString(),
            modified: true,
          },
        },
      });
    }

    case FETCH_UPDATES_SUCCESS: {
      return updateFromFetchUpdates(state, action.payload.data.humanContacts);
    }

    case SET_PENDING: {
      return setPendingFlag(state, action.data.humanContact, action.pending);
    }

    case SET_SAVED: {
      return makeObjectsSaved(state, action.data.humanContact);
    }

    default:
      return state;
  }
}
